import { render, staticRenderFns } from "./BimIfcImport.vue?vue&type=template&id=6f9b371b&scoped=true"
import script from "./BimIfcImport.vue?vue&type=script&lang=js"
export * from "./BimIfcImport.vue?vue&type=script&lang=js"
import style0 from "./BimIfcImport.vue?vue&type=style&index=0&id=6f9b371b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9b371b",
  null
  
)

export default component.exports